import AppProviders from 'app/AppProviders';
import { AppRouter } from 'routes';

/**
 * Application root. Mounts the provider stack, then the route tree.
 * Intentionally tiny — composition lives in AppProviders, routing in
 * AppRouter.
 */
export default function App() {
  return (
    <AppProviders>
      <AppRouter />
    </AppProviders>
  );
}
